<template lang="pug">
    svg( width="52" height="52" viewBox="0 0 52 52" fill="none")
        path( d="M25.9998 42.6111C35.1738 42.6111 42.6109 35.1741 42.6109 26C42.6109 16.8259 35.1738 9.38889 25.9998 9.38889C16.8257 9.38889 9.38867 16.8259 9.38867 26C9.38867 35.1741 16.8257 42.6111 25.9998 42.6111Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round")
        path( d="M33.0887 32.4492C30.9946 33.6309 28.5761 34.3053 26.0002 34.3053C23.4242 34.3053 21.0058 33.631 18.9116 32.4492" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round")
        path( d="M21.6663 22.3889C21.6663 23.5855 20.6951 24.5556 19.4997 24.5556C18.3042 24.5556 17.333 23.5854 17.333 22.3889C17.333 21.1935 18.3042 20.2222 19.4997 20.2222C20.6951 20.2222 21.6663 21.1935 21.6663 22.3889Z" :fill="color")
        path( d="M34.6663 22.3889C34.6663 23.5855 33.6952 24.5556 32.4997 24.5556C31.3042 24.5556 30.333 23.5854 30.333 22.3889C30.333 21.1935 31.3042 20.2222 32.4997 20.2222C33.6952 20.2222 34.6663 21.1935 34.6663 22.3889Z" :fill="color")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            color: VueTypes.string.def('#cecece')
        }
    };
</script>
